import styles from './StepIndicator.module.css';

const StepIndicator = ({ currentStep }) => {
  const totalSteps = 5;

  return (
    <div className={styles.indicatorContainer}>
      {Array.from({ length: totalSteps }).map((_, index) => (
        <div
          key={index}
          className={styles.circle}
          style={{
            backgroundColor: index <= currentStep ? '#FFCC00' : '#0089FF'
          }}
        />
      ))}
    </div>
  );
};

export default StepIndicator;
